import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY, WHATSAPP } from "../colors";

export const GetNotifiedAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const phoneAppear = spring({ frame, fps, config: { damping: 14 } });
  const notifDrop = spring({ frame: frame - 30, fps, config: { damping: 10, stiffness: 100 } });
  const vibrate =
    frame >= 28 && frame <= 38
      ? Math.sin(frame * 2.5) * 3
      : 0;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {/* Phone */}
      <div
        style={{
          transform: `scale(${phoneAppear}) translateX(${vibrate}px)`,
          width: 260,
          height: 330,
          borderRadius: 28,
          border: `4px solid ${GRAY[800]}`,
          backgroundColor: GRAY[900],
          overflow: "hidden",
          position: "relative",
          boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
        }}
      >
        {/* Screen */}
        <div
          style={{
            position: "absolute",
            inset: 3,
            borderRadius: 24,
            backgroundColor: "#1a1a2e",
            overflow: "hidden",
          }}
        >
          {/* Lock screen time */}
          <div style={{ textAlign: "center", paddingTop: 36 }}>
            <div style={{ fontSize: 42, fontWeight: 300, color: "white" }}>9:41</div>
            <div style={{ fontSize: 14, color: "rgba(255,255,255,0.5)", marginTop: 4 }}>
              Friday, April 4
            </div>
          </div>

          {/* Notification banner */}
          <div
            style={{
              position: "absolute",
              left: 10,
              right: 10,
              top: interpolate(notifDrop, [0, 1], [-100, 100]),
              opacity: notifDrop,
              backgroundColor: "rgba(255,255,255,0.95)",
              borderRadius: 16,
              padding: "14px 16px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
            }}
          >
            {/* Notification header */}
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <div
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: 5,
                  backgroundColor: WHATSAPP.green,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  color: "white",
                  fontWeight: 800,
                }}
              >
                W
              </div>
              <span style={{ fontSize: 14, fontWeight: 700, color: GRAY[800] }}>WhatsApp</span>
              <span style={{ fontSize: 12, color: GRAY[400], marginLeft: "auto" }}>now</span>
            </div>

            {/* Message preview */}
            <div style={{ fontSize: 14, fontWeight: 700, color: GRAY[800], marginBottom: 3 }}>
              OneTapReply
            </div>
            <div style={{ fontSize: 13, color: GRAY[500], lineHeight: 1.4 }}>
              📝 New 5★ review for Joe&apos;s Pizza
              <br />
              &quot;Best pizza in Brooklyn! The...&quot;
            </div>

            {/* Quick actions */}
            <div
              style={{
                display: "flex",
                gap: 8,
                marginTop: 10,
                borderTop: `1px solid ${GRAY[200]}`,
                paddingTop: 8,
              }}
            >
              {["✅ Approve", "✏️ Edit"].map((action) => (
                <div
                  key={action}
                  style={{
                    flex: 1,
                    textAlign: "center",
                    fontSize: 13,
                    fontWeight: 600,
                    color: BRAND[600],
                    padding: "5px 0",
                    borderRadius: 8,
                    backgroundColor: BRAND[50],
                  }}
                >
                  {action}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Notch */}
        <div
          style={{
            position: "absolute",
            top: 3,
            left: "50%",
            transform: "translateX(-50%)",
            width: 70,
            height: 20,
            borderRadius: "0 0 14px 14px",
            backgroundColor: GRAY[800],
          }}
        />
      </div>
    </AbsoluteFill>
  );
};
